<template>
    <div>
        <dialog-reset slotShow :height="dialogHeight" :width="width" top="10vh" :title="title"
            :visible.sync="stockUpShow" @close="handleClose" :beforeClose="handleClose">
            <avue-crud v-if="stockUpShow" ref="crud" :option="option" :table-loading="loading" :data="data"
                :page.sync="page" :search.sync="query" @search-change="searchChange" @search-reset="searchReset"
                :before-open="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad"
                :defaults.sync="defaults" @selection-change="selectionChange" @refresh-change="refreshChange"
                @row-click="(row, event) => { handleRowClickToSelect(row, event) }">

                <template slot-scope="scope" slot="menuLeft">
                    <!-- <el-button icon="el-icon-download" type="primary" :disabled="loading" @click="downloadXlsx"
                        v-if="downloadButton">导出</el-button> -->
                </template>
            </avue-crud>
            <el-alert v-if="billBiz.bizType == 'LUXIAO' && billBiz.billType == 'ZT'" title="提示:自提派工创建前需要确保已经进行了场内卸车派工"
                :closable="false" type="warning">
            </el-alert>
            <span slot="dialog_footer">
                <el-button icon="el-icon-circle-plus-outline" type="primary" :disabled="loading" @click="getData"
                    v-if="submitButton">确定</el-button>
                <el-button icon="el-icon-circle-close" :disabled="loading" @click="handleClose">取消</el-button>
            </span>
        </dialog-reset>
    </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";

export default {
    mixins: [crudMixins],
    props: {
        billBiz: {
            type: Object,
            default: () => {
                return {
                    bizType: '',
                    billType: ''
                }
            }
        },
        column: {
            type: Array,
            default: () => []
        },
        apiConfig: {
            type: Object,
            default: () => { }
        },
        width: {
            type: String,
            default: '1050px'
        },
        max: {
            type: Number,
            default: 999999999999
        },
        title: {
            type: String,
            default: ''
        },
        height: {
            type: String,
            default: 'calc(80vh - 280px)'
        },
        dialogHeight: {
            type: String,
            default: 'calc(80vh - 100px)'
        },
        submitButton: {
            type: Boolean,
            default: true
        },
        downloadButton: {
            type: Boolean,
            default: false
        },
        selection: {
            type: Boolean,
            default: true
        },
    },
    watch: {
        responseData(newData, oldData) {
            if (JSON.stringify(newData) == JSON.stringify(oldData)) {
                return
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    let selection = []
                    this.selectionCopy.forEach(res => {
                        newData.forEach((e, index) => {
                            if (res.id == e.id) {
                                selection.push(e)
                            }
                        })
                    });
                    if (selection.length > 0) {
                        this.$refs.crud.toggleSelection(selection);
                        // this.$refs.crud.toggleRowSelection(selection, true);
                    }
                }, 300);
            })
        }
    },
    data() {
        return {
            defaults: {},
            loading: false,
            stockUpShow: false,
            option: {
                ...this.$store.state.publicOption,
                menu: false,
                editBtn: false,
                delBtn: false,
                viewBtn: false,
                addBtn: false,
                index: true,
                columnBtn: false,
                searchShowBtn: false,
                refreshBtn: false,
                header: this.downloadButton,
                searchSpan: 6,
                searchLabelWidth: 100,
                menuWidth: 120,
                reserveSelection: true,
                selection: this.selection,
                height: this.height,
                column: this.column
            },
            queryCopy: {},
            selectionCopy: [],
            data: [],
            page: {}
        }
    },
    created() {
        this.option.column = this._.filter(this.column, (item) => {
            return item.prop != '_caozuo'
        })
    },
    methods: {
        //打开弹窗
        openDialogInfo(data = { list: [], query: {}, data: [] }) {
            this.stockUpShow = true
            this.queryCopy = data.query
            this.selectionCopy = data.list
            if (data.data) {
                    this.data = data.data
                    this.responseData = data.data
            }
            this.$forceUpdate()

            this.query = { ...this.query, ...data.query }

        },
        //获取获取的数据
        getData() {
            if (!this.selectionList.length) {
                this.$message.warning(`请选择数据`)
                return
            }
            if (this.max > 0) {
                if (this.selectionList.length > this.max) {
                    this.$message.warning(`选择数据过长，应小于等于${this.max}个数据`)
                    return
                }
            }

            this.option.column = []
            this.stockUpShow = false
            this.$emit('getData', this.selectionList)
        },
        searchReset() {
            this.query = { ...this.queryCopy };
            this.initSearchValue()
            this.onLoad(this.page, this.query);
        },
        handleClose() {
            this.stockUpShow = false
            this.$emit('handleClose')
        }
    }
}
</script>
